const ConditionalComponentWrapper = ({shouldRenderWrapper, wrapper, children}) => (shouldRenderWrapper ? wrapper(children) : children);

export default ConditionalComponentWrapper;
